<template>
  <v-page-content>
    <b-card class="w-100" responsive v-if="loaded">
      <div class="d-flex flex-wrap">
        <h4>Профессии</h4>
        <b-button variant="primary" class="d-block ml-auto" @click="onAddClick">
          Добавить
        </b-button>
      </div>
      <div>
        <b-form-group label="Дочернее общество" style="margin-bottom: calc(0.375rem + 1px)">
          <RawMultiselect class="select-subdivision" v-model="selectedOrganization" :multiple="false"
            placeholder="Выберите дочернее общество" :options="subdivisions" label="title" trackBy="id">
          </RawMultiselect>
        </b-form-group>

      </div>
      <div style="margin-bottom: calc(0.375rem + 1px)">
        <router-link :to="{
          path: `/administration/recommendation/professions-interested`,
          query: { orgId: currUser.organizationId }
        }">
          Cписок заинтересованных в целевом обучении / трудоустройстве лиц
        </router-link>
      </div>

      <!-- <div class="d-flex justify-content-end m-2">
        <b-form-checkbox v-model="onlyCurrOrg">Только {{currentOrganization.title}}</b-form-checkbox>
      </div>   -->
      <div class="card-list" v-for="(profession, index) of professionsList" :key="profession.id">
        <div v-if="(selectedOrganization && profession.organizationId === selectedOrganization.id) || !selectedOrganization">
          <ProfessionCard :currentProfession="profession" :currentOrganization="currentOrganization" @edit="onEditClick"
            @delete="onDeleteClick" :isEdit="isEdit"></ProfessionCard>
        </div>
      </div>
      <EditProfessionModal :isEdit="isEdit" :editData="selectedProfession" @save="onSaveProfession" />
      <DeleteModal id="deleteProfessionModal" title="Подтверждение удаления профессии" @delete="onDelete">
        Вы уверены?
      </DeleteModal>
    </b-card>
    <b-alert variant="primary" show class="mt-3" v-else>
      <div class="text-center">
        <b-spinner variant="primary" />
      </div>
    </b-alert>
  </v-page-content>
</template>

<script>
import EditProfessionModal from '@/components/admin/modals/recommendations/EditProfessionModal.vue'
import DeleteModal from '@/components/ui/modals/DeleteModal.vue'
import RecommendationAPI from '@/api/recommendation'
import ProfessionCard from '@/components/admin/recommendations/ProfessionCard.vue'
import OrganizationAPI from '@/api/organization'
import { mapActions, mapGetters } from 'vuex'
import { uploadFormDataFiles } from '../../helpers/professions'
import RawMultiselect from 'vue-multiselect'

export default {
  name: 'Professions',
  components: {
    EditProfessionModal,
    DeleteModal,
    ProfessionCard,
    RawMultiselect
  },
  data() {
    return {
      professionsList: [],
      editData: null,
      selectedProfession: null,
      selectedOrganization: null,
      subdivisions: [],
      currentOrganization: null,
      loaded: false,
      onlyCurrOrg: false,
      isEdit: false
    }
  },
  async created() {
    await this.getProfessionsList();
    this.currentOrganization = (await OrganizationAPI.getOrganizationById(this.currUser.organizationId)).data;
    this.loaded = true;
    this.getSubdivisions();
  },
  computed: {
    ...mapGetters({
      currUser: 'currentUser/getCurrentUser',
      storedProfessionsList: 'profession/getProfessionsList'
    })
  },
  methods: {
    isArrayEqual(x, y) {
      return _(x).differenceWith(y, _.isEqual).isEmpty();
    },
    ...mapActions({
      setProfessionsList: 'profession/fetchProfessions'
    }),
    addDirectionCodeTitle() {
      if (this.selectedProfession) {
        for (const d of this.selectedProfession.educationDirections) {
          d.codeTitle = this.getDirectionTitle(d);
        }
      }
    },
    getDirectionTitle(value) {
      return `${value.code} ${value.title}`
    },
    async getProfessionsList() {
      if (this.$store.state.profession.professions === null) {
        await this.setProfessionsList();
      }
      this.professionsList = _.sortBy(this.storedProfessionsList, 'title');
    },
    async onDelete() {
      await RecommendationAPI.deleteProfession(this.selectedProfession.id);
      await this.setProfessionsList()
      await this.getProfessionsList()
    },
    onAddClick() {
      this.isEdit = false;
      this.selectedProfession = null;
      this.$bvModal.show('editProfessionModal');
    },
    onEditClick(currentProfession) {
      this.isEdit = true;
      this.selectedProfession = currentProfession;
      this.addDirectionCodeTitle();
      this.$bvModal.show('editProfessionModal');
    },
    onDeleteClick(currentProfession) {
      this.selectedProfession = currentProfession;
      this.$bvModal.show('deleteProfessionModal');
    },
    async onSaveProfession(data) {
      console.log('onSave',_.cloneDeep(data))
      const uploadedData = await uploadFormDataFiles(data);
      const addedFiles = uploadedData.addedFiles;
      const directionsId = uploadedData.directionsId;

      data.addedFiles = addedFiles;
      data.directionsId = directionsId;
      data.organizationId = data.organization.id;
      this.loaded = false
      if (this.selectedProfession)
        await RecommendationAPI.editProfession(data);
      else
        await RecommendationAPI.addProfession(data);
      await this.setProfessionsList()
      await this.getProfessionsList()
      this.loaded = true
    },
    getSubdivisions() {
      for (const profession of this.professionsList) {
        this.subdivisions.push(profession.organization);
      }
      this.subdivisions = _.uniqBy(this.subdivisions, 'id');
    },
  }
}
</script>

<style scoped>
.ag-grid-olympics-list {
  height: calc(100vh - 230px);
}

.prof-organization {
  color: gray;
}

.icons-main-color {
  color: #017ac3;
}

.prof-item {
  margin-bottom: 1rem;
}

.prof-item:first-of-type {
  margin-top: 0;
  margin-bottom: 5px;
}

.prof-item:last-of-type {
  margin-bottom: 5px;
}

.select-subdivision {
  width: 33%;
}
</style>